import { useContext, useEffect, useState } from "react"
import { AppContext } from "./context"
import UiTooltip from "./ui_tooltip"

const BrandAuthViewStatus = ({ x, tab }) => {

    const { adsIssueList, clientAuthList, allAdsProfileIds } = useContext(AppContext)

    const [issue, setIssue] = useState(null)
    const [dspStatus, setDspStatus] = useState(null)

    useEffect(() => {
        if (tab == 'dsp') {
            setDspStatus(allAdsProfileIds.includes(x.profile?.advertiser_id))
        }
    }, [tab, allAdsProfileIds])

    useEffect(() => {
        setIssue(clientAuthList.filter(xx => !xx.status).map(xx => xx.client_info_id).includes(x.client_id))
    }, [clientAuthList])

    return (
        <div className="d-flex gap-1 justify-content-center">
            {tab == 'dsp' ?
                dspStatus === null ? null :
                dspStatus && x.profile.profile_active_status ?
                    <span className="text-success">Connected</span>
                    :
                    <UiTooltip title="Your previously connected advertising account is no longer connected. Please reauthenticate using the link below.">
                        <span className="text-danger">Issue <i className="bi bi-info-circle-fill text-danger"></i></span>
                    </UiTooltip>
                :
                adsIssueList.includes(`${x.profile.profileId || x.profile.advertiser_id}_${x.profile.client_id}`) ?
                    <UiTooltip title="This advertising profile is no longer listed as one of your connected accounts per our last refresh. Please confirm you still have access in the ads console. If you believe this is in error, please contact us at support@bispoke.io or reach out to your Customer Success Team.">
                        <span className="text-danger">Issue <i className="bi bi-info-circle-fill text-danger"></i></span>
                    </UiTooltip>
                    :
                    issue ?
                        <UiTooltip title="Your previously connected advertising account is no longer connected. Please reauthenticate using the link below.">
                            <span className="text-danger">Issue <i className="bi bi-info-circle-fill text-danger"></i></span>
                        </UiTooltip>
                        :
                        <span className="text-success">Connected</span>
            }
        </div>
    )
}

export default BrandAuthViewStatus